import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import axios from "axios";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_secure-cinema-7/artifacts/2nir2hl5_Paradigm%20Logo.png";
const API = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const year = new Date().getFullYear();
  const [email, setEmail] = useState("");

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await axios.post(`${API}/api/subscribe`, { email });
      toast.success("Thank you for subscribing! You'll receive our latest updates.");
      setEmail("");
    } catch {
      toast.success("Thank you for subscribing!");
      setEmail("");
    }
  };

  return (
    <footer data-testid="footer" className="pg-footer">
      {/* Mailing List */}
      <div style={{ background: "#fff", padding: "3.5rem 0", borderBottom: "1px solid #f0d0e8" }}>
        <div className="pg-container" style={{ textAlign: "center" }}>
          <span style={{ display: "inline-block", fontSize: ".75rem", fontWeight: 700, letterSpacing: ".12em", textTransform: "uppercase", background: "linear-gradient(135deg, #EC2E8B, #F08C6D)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent", marginBottom: ".5rem" }}>
            NEWSLETTER
          </span>
          <h3 style={{ color: "#1a1a1a", fontSize: "1.4rem", margin: "0 0 .4rem", fontFamily: "'Playfair Display', serif" }}>Stay Connected</h3>
          <p style={{ color: "#555", fontSize: ".9rem", margin: "0 0 1.5rem", maxWidth: 440, marginLeft: "auto", marginRight: "auto" }}>
            Get events, tips & tricks, and investment options delivered to your inbox
          </p>
          <form onSubmit={handleSubscribe} data-testid="mailing-list-form" style={{ display: "flex", gap: ".5rem", maxWidth: 480, margin: "0 auto", justifyContent: "center" }}>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              placeholder="Enter your email address"
              data-testid="mailing-list-input"
              style={{ flex: 1, padding: ".7rem 1rem", borderRadius: 50, border: "2px solid #e8e0e8", background: "#fff", color: "#1a1a1a", fontSize: ".9rem", outline: "none" }}
            />
            <button type="submit" data-testid="mailing-list-button" style={{ padding: ".7rem 1.5rem", borderRadius: 50, border: "none", background: "linear-gradient(135deg, #EC2E8B, #F08C6D, #E6A24A)", color: "#fff", fontWeight: 700, fontSize: ".85rem", cursor: "pointer", whiteSpace: "nowrap" }}>
              Subscribe
            </button>
          </form>
        </div>
      </div>

      <div className="pg-container">
        <div className="pg-footer-grid">
          {/* Brand */}
          <div className="pg-footer-brand">
            <Link to="/">
              <img src={LOGO_URL} alt="Paradigm Global Business Solutions" />
            </Link>
            <p>Your All-In-One Business Resource Center — serving entrepreneurs and enterprises nationwide and internationally.</p>
            <div className="pg-socials">
              <a href="https://www.facebook.com/financialfreedomdelivered" target="_blank" rel="noopener noreferrer" className="pg-soc" aria-label="Facebook"><i className="fab fa-facebook-f" /></a>
              <a href="#" className="pg-soc" aria-label="Instagram"><i className="fab fa-instagram" /></a>
              <a href="#" className="pg-soc" aria-label="LinkedIn"><i className="fab fa-linkedin-in" /></a>
              <a href="#" className="pg-soc" aria-label="Twitter"><i className="fab fa-twitter" /></a>
            </div>
          </div>

          {/* Navigate */}
          <div>
            <h5>Navigate</h5>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/book">Packages & FAQ</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h5>Programs</h5>
            <ul>
              <li><Link to="/services#business-logic">Business Logic</Link></li>
              <li><Link to="/services#iaff">Insurance + Assurance</Link></li>
              <li><Link to="/speaking">Paradigm Shift Architects</Link></li>
              <li><Link to="/services#notary-services">Notary Services</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5>Contact</h5>
            <div className="pg-fci">
              <i className="fas fa-map-marker-alt" />
              <span>Lakeland, FL — Nationwide & International</span>
            </div>
            <div className="pg-fci">
              <i className="fas fa-phone" />
              <span>(863) 585-1412</span>
            </div>
            <div className="pg-fci">
              <i className="fas fa-envelope" />
              <span>info@financialfreedomdelivered.com</span>
            </div>
            <div className="pg-fci">
              <i className="fas fa-clock" />
              <span>Mon-Fri: 9AM-5PM ET</span>
            </div>
          </div>
        </div>

        <div className="pg-footer-bottom">
          <span>&copy; {year} Paradigm Global Business Solutions. All rights reserved.</span>
          <span>THE TRUSTED RESOURCE CENTER FOR BUSINESS OWNERS</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
